// Configuração do cliente, vinda do build (variáveis VITE_*).
const env = import.meta.env;

export const config = {
  supabaseUrl: (env.VITE_SUPABASE_URL as string | undefined) || '',
  supabaseAnon: (env.VITE_SUPABASE_ANON_KEY as string | undefined) || '',
  // Desenvolvimento sem Supabase: a mesa local emite o token.
  authLocal: env.VITE_AUTH_LOCAL === '1',
  // Só no modo local: o plano de quem entra (para testar recursos de plano sem checkout).
  planoLocal: (env.VITE_PLANO_LOCAL as string | undefined) || 'gratis',
  // Só nos testes de navegador: o guia do dia fica desligado, para a folha não cobrir a aba Jogar de cada teste. Os
  // testes do guia ligam com t6:guia-do-dia-ligado no aparelho.
  semGuiaDoDia: env.VITE_SEM_GUIA_DO_DIA === '1',
  mesaUrl: (env.VITE_MESA_URL as string | undefined)
    || `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/mesa/ws`,
};

// Endereço HTTP da mesa (lista de salas e resumo pelo código), a partir do WebSocket.
export const mesaHttp = config.mesaUrl.replace(/^ws/, 'http').replace(/\/ws$/, '');
